<template>
  <page-edicion>
    <formulario-divisa />
  </page-edicion>
</template>

<script>
import FormularioDivisa from "./FormularioDivisa";
import { useDivisaStore } from "@/stores/DivisaStore";

export default {
  components: { FormularioDivisa },
  mounted() {
    useDivisaStore().$reset();
  },
};
</script>
